var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monitor-state-icon",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"circular",class:_vm.alarmAnimateClass,style:({ backgroundColor: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }